module.exports = __webpack_public_path__ + "static/sport/bgi-pc.5938945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/bgi-pc.jpg
// module id = y4ZW
// module chunks = 0